/**
 * OccupationalExam Create Page
 * Page for creating new occupational exam
 *
 * @version 2025.1.0
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Alert,
} from '@mui/material';
import { PageShell } from '../../components';
import { occupationalExamService } from '../../services/occupationalExamService';
import { OccupationalExamFormData } from '../../types/occupationalExam';
import { OccupationalExamForm } from './components/OccupationalExamForm';

export const OccupationalExamCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: OccupationalExamFormData) => {
    try {
      setIsSubmitting(true);
      setError(null);
      await occupationalExamService.createOccupationalExam(data);
      navigate('/occupational-exams');
    } catch (err: unknown) {
      const error = err as { message?: string };
      setError(error.message ?? 'Erro ao criar exame ocupacional');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/occupational-exams');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/home' },
        { label: 'Medicina', path: '/medicina' },
        { label: 'Exames Ocupacionais', path: '/occupational-exams' },
        { label: 'Novo Exame' },
      ]}
      title="Cadastrar Novo Exame Ocupacional"
      subtitle="Preencha os dados do exame ocupacional"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card>
        <CardContent sx={{ p: 3 }}>
          <OccupationalExamForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            loading={isSubmitting}
          />
        </CardContent>
      </Card>
    </PageShell>
  );
};

export default OccupationalExamCreatePage;
